import $ from 'jquery';

$(() => {
    // var shiftWindow = function() { scrollBy(0, -160) };
    // if (location.hash) shiftWindow();
    // window.addEventListener("hashchange", shiftWindow);
});
